import styled from 'styled-components';
export const Delimiter = styled.div `
  margin-top: ${({ top }) => top || '0'};
  margin-right: ${({ right }) => right || '0'};
`;
